// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"541":"sidebar","562":"accounts","809":"account"}[chunkId] || chunkId) + "." + {"541":"b316ab65","562":"bead1745","747":"f1452ffd","809":"43c9a4c3"}[chunkId] + ".chunk.js";
};